<template>
  <div class="cart">
    <Header/>
    
    <div class="breadcrumb-area gray-bg">
        <div class="container">
            <div class="breadcrumb-content">
                <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li class="active">Logout </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="cart-main-area pt-50 pb-50">
        <div class="container bg-white">
             <div class="section-title-wrap-2 section-padding-none text-center pt-25 pb-50">
                <h3 class="section-title section-bg-white">Logging you out ...</h3>
            </div>
             <i class="fa fa-spinner fa-spin mb-4 spinner product-loader"></i>
        </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
    import { mapState, mapGetter, mapActions } from 'vuex'
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import User from "../apis/user";

    export default {
        name: 'Cart',
        data () {
            return {
                
            }
        },
        created: function () {
            this.logout()  
        },
        components: {
            Header,
            Footer
        },
        methods: {
             ...mapActions("auth", ["removeUserInfo"]),

            logout() {
                var that = this

                User.logout()
                    .then((response) => {
                        setTimeout(function() { 
                            that.removeUserInfo()
                            that.$router.push({ path: "/login" })
                        }, 2500)
                        
                    })
                    .catch(function (error) {
                    //
                    });
                },
            }
        }
</script>
